import { echartVerStackedBar } from '../common';

export function echartVieBarYear(vis, datos) {
  echartVerStackedBar(
    'chartViesBar',
    'no_dataViesBar',
    datos.resultset,
    'Vehicles',
    'VIES PRINCIPALS DE LA CIUTAT: HISTÒRIC ANUAL',
    '',
  );
}
